import { route } from 'preact-router';
import { user, error, success } from '../store/state';
import { editarPerfil } from '../store/actions/user.actions';
import { Shell } from '../layout/Shell';

export function EditarPerfilView() {
  const u = user.value!;

  const onSubmit = async (e: Event) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget as HTMLFormElement);
    const payload = Object.fromEntries(fd);
    try {
      await editarPerfil(payload);
      success.value = 'Perfil actualizado.';
      route('/perfil');
    } catch (err) {
      error.value = (err as Error).message;
    }
  };

  return (
    <Shell tab="perfil">
      <h2>Editar mi perfil</h2>
      <form class="form-desktop" onSubmit={onSubmit}>
        <label>Nombre</label>
        <input name="nombre" defaultValue={u.nombre} required />
        <label>Teléfono</label>
        <input name="telefono" defaultValue={u.telefono || ''} />
        <button class="primary" type="submit">
          Guardar
        </button>
        <button class="secondary" type="button" onClick={() => route('/perfil')}>
          Cancelar
        </button>
      </form>
    </Shell>
  );
}
